// Mock data for the Loha Mart frontend

export const products = [
  {
    id: 1,
    name: 'Mild Steel Sheets',
    category: 'Mild Steel',
    price: 45000,
    unit: 'MT',
    description: 'High-quality mild steel sheets suitable for construction and manufacturing. Available in various thicknesses.',
    specifications: 'Thickness: 2mm-12mm, Width: 1250mm, Length: 2500mm',
    image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=600',
    inStock: true,
    rating: 4.5,
    reviews: 28,
  },
  {
    id: 2,
    name: 'Stainless Steel Pipes',
    category: 'Stainless Steel',
    price: 85000,
    unit: 'MT',
    description: 'Corrosion-resistant stainless steel pipes for industrial and commercial applications.',
    specifications: 'Diameter: 15mm-100mm, Grade: SS304, SS316',
    image: 'https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?w=600',
    inStock: true,
    rating: 4.8,
    reviews: 42,
  },
  {
    id: 3,
    name: 'TMT Steel Bars',
    category: 'Construction Steel',
    price: 52000,
    unit: 'MT',
    description: 'Thermo-Mechanically Treated steel bars for construction. High strength and ductility.',
    specifications: 'Sizes: 8mm-32mm, Grade: Fe500D, Fe550D',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600',
    inStock: true,
    rating: 4.7,
    reviews: 35,
  },
  {
    id: 4,
    name: 'Aluminum Sheets',
    category: 'Non Ferrous',
    price: 235000,
    unit: 'MT',
    description: 'Lightweight aluminum sheets for various industrial applications. Excellent corrosion resistance.',
    specifications: 'Thickness: 0.5mm-6mm, Width: 1000mm-1500mm',
    image: 'https://images.unsplash.com/photo-1611085583191-a3b181a88401?w=600',
    inStock: true,
    rating: 4.6,
    reviews: 19,
  },
  {
    id: 5,
    name: 'Copper Rods',
    category: 'Non Ferrous',
    price: 750000,
    unit: 'MT',
    description: 'Pure copper rods for electrical and industrial use. High conductivity.',
    specifications: 'Diameter: 10mm-50mm, Purity: 99.9%',
    image: 'https://images.unsplash.com/photo-1565857923431-eb958c72e730?w=600',
    inStock: false,
    rating: 4.9,
    reviews: 15,
  },
  {
    id: 6,
    name: 'GI Pipes',
    category: 'Pipes & Tubes',
    price: 58000,
    unit: 'MT',
    description: 'Galvanized Iron pipes for water supply and construction. Rust-resistant coating.',
    specifications: 'Diameter: 15mm-150mm, Thickness: Medium, Heavy',
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=600',
    inStock: true,
    rating: 4.4,
    reviews: 31,
  },
];

export const categories = [
  {
    id: 1,
    name: 'Steel & Structural Materials',
    slug: 'steel-structural',
    description: 'Complete range of steel products',
    icon: 'Package',
    image: 'https://images.unsplash.com/photo-1587293852726-70cdb56c2866?w=400&h=400&fit=crop',
    productsCount: 45,
    subcategories: [
      { id: 11, name: 'TMT Bars', slug: 'tmt-bars', description: 'Fe500, Fe550 grades' },
      { id: 12, name: 'MS Plates', slug: 'ms-plates', description: 'Various thicknesses' },
      { id: 13, name: 'Structural Sections', slug: 'structural-sections', description: 'Beams, Channels, Angles' },
      { id: 14, name: 'GP/HR/CR Coils', slug: 'coils', description: 'Cold & Hot Rolled' },
      { id: 15, name: 'Scaffolding Materials', slug: 'scaffolding', description: 'Complete scaffolding solutions' },
    ],
  },
  {
    id: 2,
    name: 'Pipes & Tubes',
    slug: 'pipes-tubes',
    description: 'All types of pipes and tubes',
    icon: 'Layers',
    image: 'https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?w=400&h=400&fit=crop',
    productsCount: 38,
    subcategories: [
      { id: 21, name: 'MS Pipes', slug: 'ms-pipes', description: 'Black & Galvanized' },
      { id: 22, name: 'Stainless Steel Pipes', slug: 'ss-pipes', description: 'SS304, SS316' },
      { id: 23, name: 'GI Pipes', slug: 'gi-pipes', description: 'Medium & Heavy duty' },
      { id: 24, name: 'Seamless Pipes', slug: 'seamless-pipes', description: 'High pressure applications' },
      { id: 25, name: 'Structural Tubes', slug: 'structural-tubes', description: 'Square & Rectangular' },
    ],
  },
  {
    id: 3,
    name: 'Construction Chemicals',
    slug: 'construction-chemicals',
    description: 'Complete chemical solutions',
    icon: 'Zap',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=400&h=400&fit=crop',
    productsCount: 28,
    subcategories: [
      { id: 31, name: 'Admixtures', slug: 'admixtures', description: 'Concrete additives' },
      { id: 32, name: 'Waterproofing', slug: 'waterproofing', description: 'Membrane & Coating' },
      { id: 33, name: 'Epoxy & Grouts', slug: 'epoxy-grouts', description: 'Floor & Joint solutions' },
      { id: 34, name: 'Paints & Coatings', slug: 'paints-coatings', description: 'Industrial grade' },
      { id: 35, name: 'Sealants & Adhesives', slug: 'sealants', description: 'Various applications' },
    ],
  },
  {
    id: 4,
    name: 'Raw Materials',
    slug: 'raw-materials',
    description: 'Construction raw materials',
    icon: 'Building',
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=400&h=400&fit=crop',
    productsCount: 52,
    subcategories: [
      { id: 41, name: 'Bitumen', slug: 'bitumen', description: 'VG10, VG30, VG40' },
      { id: 42, name: 'Fly Ash', slug: 'fly-ash', description: 'Grade 1 & 2' },
      { id: 43, name: 'Cement', slug: 'cement', description: 'OPC, PPC grades' },
      { id: 44, name: 'Aggregates', slug: 'aggregates', description: 'Sand, Gravel, Stone' },
      { id: 45, name: 'LRPC Strand', slug: 'lrpc-strand', description: 'Pre-stressing strand' },
    ],
  },
  {
    id: 5,
    name: 'Crash Barriers',
    slug: 'crash-barriers',
    description: 'Highway safety solutions',
    icon: 'Wrench',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=400&h=400&fit=crop',
    productsCount: 32,
    subcategories: [
      { id: 51, name: 'W-Beam Barriers', slug: 'w-beam', description: 'Standard highway barriers' },
      { id: 52, name: 'Thrie Beam Barriers', slug: 'thrie-beam', description: 'Heavy duty barriers' },
      { id: 53, name: 'Posts & Accessories', slug: 'posts-accessories', description: 'Complete fittings' },
      { id: 54, name: 'Road Safety Items', slug: 'road-safety', description: 'Reflectors, Delineators' },
    ],
  },
  {
    id: 6,
    name: 'Shuttering Materials',
    slug: 'shuttering-materials',
    description: 'Formwork solutions',
    icon: 'Hammer',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=400&h=400&fit=crop',
    productsCount: 41,
    subcategories: [
      { id: 61, name: 'Shuttering Plates', slug: 'shuttering-plates', description: 'MS & Plywood' },
      { id: 62, name: 'Props & Jacks', slug: 'props-jacks', description: 'Adjustable supports' },
      { id: 63, name: 'Formwork Accessories', slug: 'formwork-accessories', description: 'Clamps, Ties, Couplers' },
      { id: 64, name: 'Centering Materials', slug: 'centering-materials', description: 'Complete centering solutions' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    company: 'Kumar Steel Industries',
    role: 'Procurement Manager',
    image: 'https://randomuser.me/api/portraits/men/1.jpg',
    rating: 5,
    text: 'Loha Mart has been our trusted partner for over 2 years. The quality of materials and timely delivery is exceptional. Their customer service team is always responsive and helpful.',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    company: 'Sharma Construction',
    role: 'Project Director',
    image: 'https://randomuser.me/api/portraits/women/2.jpg',
    rating: 5,
    text: 'The credit facility and competitive pricing have helped us scale our business significantly. We\'ve saved over 15% on procurement costs. Highly recommended!',
  },
  {
    id: 3,
    name: 'Amit Patel',
    company: 'Patel Manufacturing',
    role: 'CEO',
    image: 'https://randomuser.me/api/portraits/men/3.jpg',
    rating: 5,
    text: 'Excellent platform with a wide range of products. The quality assurance and certification process gives us confidence. The online quote system saves us a lot of time.',
  },
  {
    id: 4,
    name: 'Sunita Reddy',
    company: 'Reddy Enterprises',
    role: 'Owner',
    image: 'https://randomuser.me/api/portraits/women/4.jpg',
    rating: 5,
    text: 'As a small business owner, the flexible payment terms have been a game-changer. The team understands our needs and always goes the extra mile to help.',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ShieldCheck',
    title: 'Quality Assured',
    description: 'All materials tested and certified to meet industry standards. 100% quality guarantee on every order.',
  },
  {
    id: 2,
    icon: 'TrendingDown',
    title: 'Best Prices',
    description: 'Competitive pricing with market insights. Get the best deals and save up to 15% on bulk orders.',
  },
  {
    id: 3,
    icon: 'Truck',
    title: 'Fast Delivery',
    description: 'Pan-India delivery network. Most orders delivered within 3-7 business days with real-time tracking.',
  },
  {
    id: 4,
    icon: 'CreditCard',
    title: 'Flexible Payment',
    description: 'Multiple payment options including credit facility for eligible customers. Easy EMI available.',
  },
  {
    id: 5,
    icon: 'Headphones',
    title: '24/7 Support',
    description: 'Dedicated customer support team available round the clock to assist you with any queries.',
  },
  {
    id: 6,
    icon: 'FileCheck',
    title: 'Easy Documentation',
    description: 'Streamlined documentation process. Get invoices, delivery notes, and certificates instantly.',
  },
];

export const stats = [
  { id: 1, value: '500K+', label: 'Orders Delivered' },
  { id: 2, value: '10K+', label: 'Happy Customers' },
  { id: 3, value: '26', label: 'States Covered' },
  { id: 4, value: '99.5%', label: 'Customer Satisfaction' },
];

export const faqs = [
  {
    id: 1,
    question: 'What are your delivery timelines?',
    answer: 'Delivery timelines vary based on location and product availability. Typically, we deliver within 3-7 business days for most locations across India. For urgent requirements, express delivery options are available.',
  },
  {
    id: 2,
    question: 'Do you offer credit facilities?',
    answer: 'Yes, we offer flexible credit options for eligible businesses. After a quick verification process, approved customers can access credit limits based on their business profile and requirements.',
  },
  {
    id: 3,
    question: 'How can I track my order?',
    answer: 'Once your order is placed, you can track it through your account dashboard. You\'ll also receive tracking updates via SMS and email with real-time status of your delivery.',
  },
  {
    id: 4,
    question: 'What is your return policy?',
    answer: 'We accept returns within 7 days of delivery for damaged or defective products. Please contact our support team immediately with photos of the issue, and we\'ll arrange for replacement or refund.',
  },
  {
    id: 5,
    question: 'Do you provide quality certificates?',
    answer: 'Yes, all our products come with quality certificates and test reports from authorized labs. Material test certificates (MTC) are provided for steel and metal products.',
  },
  {
    id: 6,
    question: 'Can I get a custom quote?',
    answer: 'Absolutely! You can request custom quotes for specific quantities, specifications, or bulk orders. Our team will respond with a detailed quote within 24 hours.',
  },
];

export const blogPosts = [
  {
    id: 1,
    title: 'Understanding Different Grades of Steel',
    excerpt: 'A comprehensive guide to various steel grades and their applications in construction and manufacturing...',
    image: 'https://images.unsplash.com/photo-1565857923431-eb958c72e730?w=600',
    author: 'Technical Team',
    date: '2024-12-15',
    category: 'Education',
    readTime: '5 min read',
  },
  {
    id: 2,
    title: 'How to Choose the Right Stainless Steel Grade',
    excerpt: 'Stainless steel comes in various grades. Learn which grade is best suited for your specific application...',
    image: 'https://images.unsplash.com/photo-1601574968106-b312ac309953?w=600',
    author: 'Material Expert',
    date: '2024-12-10',
    category: 'Guide',
    readTime: '7 min read',
  },
  {
    id: 3,
    title: 'Top 10 Quality Checks for Construction Materials',
    excerpt: 'Essential quality checks you should perform before accepting construction materials on your site...',
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?w=600',
    author: 'Quality Team',
    date: '2024-12-05',
    category: 'Tips',
    readTime: '6 min read',
  },
];
